import React from "react";
import { node, number } from "prop-types";
import { Col } from "../Grid";

const GuidePageTemplateSidebar = ({ md = 4, children, ...props }) => {
	return (
		<Col md={md} {...props}>
			<div className="guide-page-template__sidebar">{children}</div>
		</Col>
	);
};

GuidePageTemplateSidebar.propTypes = {
	children: node.isRequired,
	md: number,
};

export default GuidePageTemplateSidebar;
